import React from 'react';
import PropTypes from 'prop-types';
import PickersSliderHighlight from 'components/pickers-slider-highlight';

export default function Pickers({ title, text, pickers }) {
    return (
        <div className="cms-pickers">
            <div className="cms-pickers--title">{title}</div>
            <div className="cms-pickers--slider">
                <PickersSliderHighlight pickers={pickers.pickers} />
            </div>
            <div className="cms-pickers--text" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
}

Pickers.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    pickers: PropTypes.shape({
        pickers: PropTypes.array.isRequired,
        total_count: PropTypes.number.isRequired,
    }),
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/pickers/index.js